/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Mock_F1Inputs */

const en_cp_mock_f1 = /** @type {(inputs: Cp_Mock_F1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Staff & patient login`)
};

const id_cp_mock_f1 = /** @type {(inputs: Cp_Mock_F1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Login petugas & pasien`)
};

/**
* | output |
* | --- |
* | "Staff & patient login" |
*
* @param {Cp_Mock_F1Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_mock_f1 = /** @type {((inputs?: Cp_Mock_F1Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Mock_F1Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_mock_f1(inputs)
	return en_cp_mock_f1(inputs)
});